import createDOMPurify from 'dompurify';

const EducationDOMPurify = createDOMPurify();

EducationDOMPurify.addHook('afterSanitizeAttributes', (node) => {
  // set all elements owning href to target=_blank
  if (node.hasAttribute('href')) {
    node.setAttribute('target', '_blank');
    // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export { EducationDOMPurify };
